export const validate = {
  questionRadio(userAnswer) {
    return {
      isValid: userAnswer !== null,
    };
  },
  questionPercent(userAnswer) {
    if (userAnswer === null) {
      return {
        isValid: false,
      };
    }
    const isValid = userAnswer >= 0 && userAnswer <= 100;
    return {
      isValid,
      errorMessage: !isValid
        ? 'Please enter a number between 0 and 100.'
        : undefined,
    };
  },
  questionMultiselect(userAnswer) {
    return {
      isValid: (userAnswer && userAnswer.length > 0) || false,
    };
  },
};

export const getFirstQuestionInSection = (questions, sectionId) =>
  questions
    .filter((q) => q.sectionId === sectionId)
    .sort((a, b) => a.order - b.order)[0];

export const SURVEY_DIRECTION = {
  NEXT: 'next',
  PREVIOUS: 'previous',
};
